import { render, staticRenderFns } from "./AccountLoginView.vue?vue&type=template&id=2f0671dc&scoped=true&"
import script from "./AccountLoginView.vue?vue&type=script&lang=js&"
export * from "./AccountLoginView.vue?vue&type=script&lang=js&"
import style0 from "./AccountLoginView.vue?vue&type=style&index=0&id=2f0671dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0671dc",
  null
  
)

/* custom blocks */
import block0 from "./AccountLoginView.vue?vue&type=custom&index=0&blockType=translations"
if (typeof block0 === 'function') block0(component)

export default component.exports